/**
 * @generated SignedSource<<801e2ca70aa20112b0d92c3676f523c8>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CloudProvider = "AWS" | "Azure" | "GCP" | "Kubernetes" | "TencentCloud" | "%future added value";
export type UpdatePolicyCollectionInput = {
  autoUpdate?: boolean | null | undefined;
  description?: string | null | undefined;
  name?: string | null | undefined;
  provider?: CloudProvider | null | undefined;
  repositoryView?: RepositoryViewInput | null | undefined;
  uuid: string;
};
export type RepositoryViewInput = {
  branchName?: string | null | undefined;
  policyDirectories?: ReadonlyArray<string> | null | undefined;
  policyFileSuffix?: ReadonlyArray<string> | null | undefined;
};
export type UpdatePolicyCollectionMutation$variables = {
  input: UpdatePolicyCollectionInput;
};
export type UpdatePolicyCollectionMutation$data = {
  readonly updatePolicyCollection: {
    readonly collection: {
      readonly autoUpdate: boolean;
      readonly description: string | null | undefined;
      readonly id: string;
      readonly name: string;
      readonly policyMappings: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly policy: {
              readonly name: string;
              readonly uuid: any;
              readonly version: number;
            };
          };
        }>;
      };
      readonly uuid: any;
    } | null | undefined;
  } | null | undefined;
};
export type UpdatePolicyCollectionMutation = {
  response: UpdatePolicyCollectionMutation$data;
  variables: UpdatePolicyCollectionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "autoUpdate",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uuid",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "version",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdatePolicyCollectionMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "PolicyCollectionPayload",
        "kind": "LinkedField",
        "name": "updatePolicyCollection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PolicyCollection",
            "kind": "LinkedField",
            "name": "collection",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              (v3/*:: as any*/),
              (v4/*:: as any*/),
              (v5/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "PolicyCollectionMappingConnection",
                "kind": "LinkedField",
                "name": "policyMappings",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PolicyCollectionMappingEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PolicyCollectionMapping",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Policy",
                            "kind": "LinkedField",
                            "name": "policy",
                            "plural": false,
                            "selections": [
                              (v5/*:: as any*/),
                              (v6/*:: as any*/),
                              (v7/*:: as any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v6/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "UpdatePolicyCollectionMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "PolicyCollectionPayload",
        "kind": "LinkedField",
        "name": "updatePolicyCollection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PolicyCollection",
            "kind": "LinkedField",
            "name": "collection",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              (v3/*:: as any*/),
              (v4/*:: as any*/),
              (v5/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "PolicyCollectionMappingConnection",
                "kind": "LinkedField",
                "name": "policyMappings",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PolicyCollectionMappingEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PolicyCollectionMapping",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Policy",
                            "kind": "LinkedField",
                            "name": "policy",
                            "plural": false,
                            "selections": [
                              (v5/*:: as any*/),
                              (v6/*:: as any*/),
                              (v7/*:: as any*/),
                              (v4/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          (v4/*:: as any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v6/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "71e894bc77b27d86911b45f177dae10b",
    "id": null,
    "metadata": {},
    "name": "UpdatePolicyCollectionMutation",
    "operationKind": "mutation",
    "text": "mutation UpdatePolicyCollectionMutation(\n  $input: UpdatePolicyCollectionInput!\n) {\n  updatePolicyCollection(input: $input) {\n    collection {\n      autoUpdate\n      description\n      id\n      name\n      policyMappings {\n        edges {\n          node {\n            policy {\n              name\n              uuid\n              version\n              id\n            }\n            id\n          }\n        }\n      }\n      uuid\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "602cd8a96458dff30e5f8159720c9be4";

export default node;
